import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ReactSVG } from "react-svg";
import printicon from "../../../../assets/images/print-icon.svg";
import editicon from "../../../../assets/images/edit-icon.svg";
import duplicateicon from "../../../../assets/images/duplicate-icon.svg";
import deleteicon from "../../../../assets/images/delete-icon.svg";
import { toggleClass } from "../../../../utils/commonUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { DeleteConfirmModel } from "../../Itemlisting/popUpModels/deleteConfModel";
import useInventory from "../../../../Hooks/useInventory";
import { selectCurrentUserId } from "../../../../redux/auth/authSlice";
import { useAppSelector } from "../../../../redux/hooks";
import PrintBarcodeLabelDropdown from "../../../../components/printBarcodeLabelDropdown/printBarcodeLabelDropdown";
import AddItem from "../../AddInventory/AddItem";
import reporticon from "../../../../assets/images/report-icon.svg";
import {
  checkPermission,
  PermissionModule,
  PermissionIdentifier,
} from "../../../../utils/permissionUtils";

export const BasicInfoTab = ({
  toggleBarcodeModal,
  selectedItem,
  toggleDuplicateModal,
  selectedLabel,
  setSelectedLabel,
  settingsList,
  useFor,
  setUseFor,
  onShowReportModal,
}: any) => {
  const currentUserId = useAppSelector(selectCurrentUserId);
  const childRef = useRef<{
    printBarcode: (labelId: string, selectedItem: any) => void;
  }>(null);
  const { deleteInventoryItemAPI } = useInventory();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const editUser = () => {
    setUseFor("Edit");
  };
  const deleteItem = async () => {
    await deleteInventoryItemAPI({
      id: selectedItem?.id,
      deletedBy: currentUserId,
    });
    onClose();
    navigate("/inventory");
  };
  const onClose = () => {
    toggleClass();
    setShowModal(!showModal);
  };
  const toggleDelModal = (item: any) => {
    toggleClass();
    setShowModal(!showModal);
  };
  const handlePrintBarcode = () => {
    if (childRef.current && selectedLabel) {
      childRef.current?.printBarcode(selectedLabel?.value, selectedItem); // Pass the selected label and a barcode ID
    }
  };
  useEffect(() => {
    if (location.pathname === "/edit-inventory") {
      editUser();
    }
  }, []);

  return (
    <div className="invt-overview-content-wrapper">
      <div className="invt-overview-section-title">
        <div className="inventory-actions-box-wrapper">
          {checkPermission(
            PermissionModule.INVENTORY,
            PermissionIdentifier.PRINT_BARCODE
          ) && (
            <>
              <PrintBarcodeLabelDropdown
                setSelectedLabel={setSelectedLabel}
                selectedLabel={selectedLabel}
                ref={childRef} // Pass the ref to the child component
              />
              <div className="print-barcode-btn-box">
                <span
                  className="print-barcode-btn"
                  onClick={handlePrintBarcode}
                >
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={printicon}
                  />
                  Print Barcode
                </span>
              </div>
            </>
          )}
          <div className="inventory-actions-box">
            {checkPermission(
              PermissionModule.RX,
              PermissionIdentifier.EDIT_INVENTORY_ITEM
            ) && (
              <span
                className="invt-action-btn envt-edit-btn"
                onClick={editUser}
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>Edit</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <ReactSVG className="svg-box" wrapper="span" src={editicon} />
                </OverlayTrigger>
              </span>
            )}
            {checkPermission(
              PermissionModule.RX,
              PermissionIdentifier.DUPLICATE_INVENTORY_ITEM
            ) && (
              <span
                className="invt-action-btn envt-duplicate-btn"
                onClick={toggleDuplicateModal}
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>Duplicate</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={duplicateicon}
                  />
                </OverlayTrigger>
              </span>
            )}
            {checkPermission(
              PermissionModule.RX,
              PermissionIdentifier.DELETE_INVENTORY_ITEM
            ) && (
              <span
                className="invt-action-btn envt-delete-btn"
                onClick={toggleDelModal}
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip>Delete</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={deleteicon}
                  />
                </OverlayTrigger>
              </span>
            )}
            {checkPermission(
              PermissionModule.INVENTORY,
              PermissionIdentifier.VIEW_INVENTORY_REPORT
            ) && (
              <span
                className="invt-action-btn envt-delete-btn"
                onClick={onShowReportModal}
              >
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  overlay={<Tooltip> Transaction Report</Tooltip>}
                  trigger={["hover", "focus"]}
                >
                  <ReactSVG
                    className="svg-box"
                    wrapper="span"
                    src={reporticon}
                  />
                </OverlayTrigger>
              </span>
            )}
          </div>
        </div>
      </div>
      <AddItem isUseFor={useFor} setIsUseFor={setUseFor} />
      <DeleteConfirmModel
        showModal={showModal}
        onClose={onClose}
        item={selectedItem}
        deleteItem={deleteItem}
      />
    </div>
  );
};
